import { render, staticRenderFns } from "./PoHomeworkListForGroup.vue?vue&type=template&id=8d403014"
import script from "./PoHomeworkListForGroup.vue?vue&type=script&lang=js"
export * from "./PoHomeworkListForGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports